export default [
    {
        path: '/hourGroupDates',
        name: 'hourGroupDates',
        component: () => import ('./pages/index')
    },
]